export const environment = {
	production: true,
	baseUrl: '.',
	recaptchaKey: '6LcSZlAbAAAAALm3O5Immxzz3RAJ70Tdhp8krplE'
};
